import React from 'react';

const TypingIndicator: React.FC = () => (
  <div className="flex items-center gap-1 px-4 py-3">
    <div className="flex gap-1">
      <span
        className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
        style={{ animationDelay: '0ms', animationDuration: '1s' }}
      />
      <span
        className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
        style={{ animationDelay: '200ms', animationDuration: '1s' }}
      />
      <span
        className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
        style={{ animationDelay: '400ms', animationDuration: '1s' }}
      />
    </div>
    <span className="ml-2 text-sm text-gray-500">Analisando dados...</span>
  </div>
);

export default TypingIndicator;
